import { render, staticRenderFns } from "./BreadcrumbRoles.vue?vue&type=template&id=141d1798&scoped=true&"
import script from "./BreadcrumbRoles.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbRoles.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbRoles.vue?vue&type=style&index=0&id=141d1798&prod&lang=css&"
import style1 from "./BreadcrumbRoles.vue?vue&type=style&index=1&id=141d1798&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141d1798",
  null
  
)

export default component.exports